import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { LeapmotorElementDTO } from '../../../models/elements-dto';
import { ElementType } from '../../../enums/elements';
import { ElementService } from '../../../services/elements-service';
import { TrackingService } from '../../../services/tracking.service';
import { LogType } from '../../../enums/logtype';
@Component({
  selector: 'app-novelty',
  templateUrl: './novelty.component.html',
  styleUrls: ['./novelty.component.scss'],
})
export class NoveltyComponent implements OnInit {
  data: LeapmotorElementDTO[] = [];
  type = ElementType.Novedades;

  constructor(
    private noveltyService: ElementService,
    private trackingService: TrackingService
  ) {}

  ngOnInit(): void {
    this.noveltyService.GetLeapmotorElementLst(this.type).subscribe(
      (resp) => {
        this.data = resp;
      },
      (err) => {
        Swal.fire({
          icon: 'info',
          title: 'Cargando...',
          text: 'Espere por favor',
        });
      }
    );
  }
  TrackNovelty(id: string) {
    this.trackingService.trackElement(id, LogType.NavNovelty).subscribe();
  }
}
